import axios from "axios";
import { authService } from "../services/auth_service";

const api = axios.create({
  baseURL: process.env.API_URL || "NA",
  timeout: 1200000,
  // headers: { ... }
});

export const tokenAPI = axios.create({
  baseURL: process.env.API_URL || "NA",
  timeout: 1200000,
  // headers: { ... }
});

api.interceptors.request.use(
  async (req) => {
    let token = authService.getAccessToken();
    if (!token) {
      await authService.setNewToken();
      req.headers.Authorization = `Bearer ${authService.getAccessToken()}`;
    }
    if (token) {
      const isTokenExpired = await authService.isTokenExpired();
      console.log("isTokenExpired", isTokenExpired);
      if (isTokenExpired) {
        await authService.setNewToken();
      }
      req.headers.Authorization = `Bearer ${authService.getAccessToken()}`;
    }
    return req;
  },
  (error) => {
    console.log("ERRO in axios interceptor ", error);
  }
);

api.interceptors.response.use(
  (response) => response, // pass through successful responses
  (error) => {
    if (error.response) {
      // The request was made and server responded with a status outside2xx
      console.error("Error data:", error.response.data);
      console.error("Status:", error.response.status);
      // Handle specific status codes:
      if (error.response.status === 404) {
        // For example, redirect to login on unauthorized
        window.location.href = "/error404.html";
      } else if (error.response.status === 500) {
        window.location.href = "/error500.html";
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error("No response received:", error.request);
    } else {
      // Something happened setting up the request
      console.error("Error message:", error.message);
    }
    // Always reject the error so it can be handled further if needed
    return Promise.reject(error);
  }
);

export default api;
